import { useTranslations } from "@zapier/i18n";
import { HeaderButton, useEmitTrashNavClickEvent } from "@zapier/shared";
import styles from "./TrashButton.module.css";

interface Props {
  href: string;
  /** Hides this button at the --desktop breakpoint, where a sidebar TrashLink is shown instead. */
  mobileOnly?: boolean;
}

export function TrashButton({ href, mobileOnly }: Props) {
  const t = useTranslations("trash-button");
  const { emit: emitTrashNavClick } = useEmitTrashNavClickEvent();

  const button = (
    <HeaderButton
      icon="actionTrash"
      ariaLabel={t("labels.access-trash")}
      tooltipContent={t("labels.access-trash")}
      href={href}
      buttonText={t("buttons.trash")}
      buttonColor="ghost"
      iconButtonColor="ghost"
      onClick={() => emitTrashNavClick("header")}
    />
  );

  if (!mobileOnly) {
    return button;
  }

  return <div className={styles.mobileOnly}>{button}</div>;
}
